module.exports = __webpack_public_path__ + "static/media/REW_Saved.4baed4f8.jpg";